import { Injectable } from '@angular/core';
import { HttpRequest, HttpResponse } from '@angular/common/http';

import { Cache } from '../../helpers/cache';
import { CacheEntry, MAX_CACHE_AGE } from '../../helpers/cache-entry';;

@Injectable()

export class CacheMapService implements Cache {
  constructor() { }

  cacheMap = new Map<string, CacheEntry>();

  get(req: HttpRequest<any>): HttpResponse<any> | null {
    const entry = JSON.parse(localStorage.getItem(req.url));
    if (!entry) {
      return null;
    }
    const isExpired = (Date.now() - entry.entryTime) > MAX_CACHE_AGE;
    return isExpired ? null : new HttpResponse(entry.response);
  }

  put(req: HttpRequest<any>, res: HttpResponse<any>): void {
    const entry: CacheEntry = { url: req.urlWithParams, response: res, entryTime: Date.now() };
    let cachedata = JSON.stringify(entry);
    localStorage.setItem(req.url, cachedata);
    this.deleteExpiredCache();
  }



  deleteExpiredCache() {
    const THEME_KEYS = new Set([
      "bg-color", "logoImage", "btn-font-color", "theme-name", "tab-font-color", "tab-color"
    ]);

    Object.keys(localStorage).forEach((key) => {
      if (THEME_KEYS.has(key)) return;

      const raw = localStorage.getItem(key);
      if (raw === null) return;

      if (raw.startsWith('U2FsdGVkX1')) {
        console.debug(`Skipping encrypted entry: ${key}`);
        return;
      }

      if (!raw.trim().startsWith('{')) {
        console.debug(`Skipping non-JSON entry: ${key} (starts with: ${raw.slice(0, 20)}...)`);
        return;
      }

      try {
        const data = JSON.parse(raw);

        if (!data ||
          typeof data.entryTime !== 'number' ||
          isNaN(data.entryTime) ||
          !data.url) {
          console.warn('Invalid cache structure for key: ' + key);
          return;
        }

        const ageMs = Date.now() - data.entryTime;
        if (ageMs > MAX_CACHE_AGE) {
          console.log(`Expiring cache: ${key} (${(ageMs / 3600000).toFixed(1)}h old)`);
          this.cacheMap.delete(data.url);
          localStorage.removeItem(key);
        }

      } catch (err) {
        console.warn(`Failed to parse cache entry "${key}":`, err.message);
      }
    });
  }
}
